// import {
//   CONFIRMED_CREATE_RECEPTIONIST_ACTION,
//   CONFIRMED_MARK_PATIENT_CURRENT,
//   CONFIRMED_EDIT_RECEPTIONIST_ACTION,
//   CONFIRMED_GET_RECEPTIONISTS,
//   CONFIRMED_DELETE_RECEPTIONIST_ACTION,
//   CONFIRMED_ADD_VITALS_ACTION,
//   CONFIRMED_COLLECT_PAYMENT_ACTION,
//   CONFIRMED_UPCOMING_APPOINTMENT,
//   CONFIRMED_GET_AVAILABLE_SLOTS,
//   CONFIRMED_RESCHEDULE_APPOINTMENT,
//   CONFIRMED_RESCHEDULE_QUEUE_APPOINTMENT,
//   CONFIRMED_SEND_FORM_LINK,
//   CONFIRMED_PAUSE_DOCTOR_QUEUE,
//   CONFIRMED_MARK_PATIENT_EMERGENCY,
// } from "../actions/ReceptionistTypes";

// const initialState = {
//   receptionists: [],
//   vitals: [],
//   currentPatient: null,
//   upcomingAppointments: [],
//   availableSlots: [], // Add availableSlots to initial state
//   sentLinks: [],
//   emergencyPatients: [], 
//   isPaused: false, 
// };

// export default function ReceptionistReducer(state = initialState, action) {
//   // In your reducer
//   // if (action.type === CONFIRMED_GET_RECEPTIONISTS) {
//   //   // Deep compare to prevent unnecessary updates
//   //   if (
//   //     JSON.stringify(state.receptionists) !== JSON.stringify(action.payload)
//   //   ) {
//   //     return {
//   //       ...state,
//   //       receptionists: action.payload,
//   //     };
//   //   }
//   //   return state;
//   // }
//   if (action.type === CONFIRMED_GET_RECEPTIONISTS) {
//     const { receptionists, isPaused } = action.payload;

//     if (
//       JSON.stringify(state.receptionists) !== JSON.stringify(receptionists) ||
//       state.isPaused !== isPaused
//     ) {
//       return {
//         ...state,
//         receptionists,
//         isPaused,
//       };
//     }
//     return state;
//   }


//   if (action.type === CONFIRMED_CREATE_RECEPTIONIST_ACTION) {
//     const receptionists = [...state.receptionists];
//     receptionists.push(action.payload);

//     return {
//       ...state,
//       receptionists,
//     };
//   }
//   if (action.type === CONFIRMED_MARK_PATIENT_CURRENT) {
//     return {
//       ...state,
//       currentPatient: action.payload,
//     };
//   }

//   if (action.type === CONFIRMED_ADD_VITALS_ACTION) {
//     const vitals = [...state.vitals];
//     vitals.push(action.payload);

//     return {
//       ...state,
//       vitals,
//     };
//   }

//   if (action.type === CONFIRMED_COLLECT_PAYMENT_ACTION) {
//     // const payments = [...state.payments];
//     // payments.push(action.payload);
//     // return {
//     //   ...state,
//     //   payments,
//     // };
//   }
//   if (action.type === CONFIRMED_UPCOMING_APPOINTMENT) {
//     return {
//       ...state,
//       upcomingAppointments: action.payload, // Update to use upcomingAppointments instead of tomorrowAppointments
//     };
//   }

//   if (action.type === CONFIRMED_GET_AVAILABLE_SLOTS) {
//     return {
//       ...state,
//       availableSlots: action.payload,
//     };
//   }

//   if (action.type === CONFIRMED_RESCHEDULE_APPOINTMENT) {
//     // Update the upcoming appointments list after rescheduling
//     const updatedAppointments = state.upcomingAppointments.map((appointment) =>
//       appointment.queue_id === action.payload.queue_id
//         ? action.payload
//         : appointment
//     );

//     return {
//       ...state,
//       upcomingAppointments: updatedAppointments,
//     };
//   }

//   if (action.type === CONFIRMED_RESCHEDULE_QUEUE_APPOINTMENT) {
//     // Update the upcoming appointments list after rescheduling
//     const updatedAppointments = state.upcomingAppointments.map((appointment) =>
//       appointment.queue_id === action.payload.queue_id
//         ? action.payload
//         : appointment
//     );

//     return {
//       ...state,
//       upcomingAppointments: updatedAppointments,
//     };
//   }

//   // Add edit and delete cases if needed
//   if (action.type === CONFIRMED_EDIT_RECEPTIONIST_ACTION) {
//     const updatedList = state.receptionists.map((item) =>
//       item.id === action.payload.id ? action.payload : item
//     );
//     return {
//       ...state,
//       receptionists: updatedList,
//     };
//   }

//   if (action.type === CONFIRMED_DELETE_RECEPTIONIST_ACTION) {
//     const filteredList = state.receptionists.filter(
//       (item) => item.id !== action.payload
//     );
//     return {
//       ...state,
//       receptionists: filteredList,
//     };
//   }
//   if (action.type === CONFIRMED_SEND_FORM_LINK) {
//     return {
//       ...state,
//       sentLinks: [...state.sentLinks, action.payload], 
//     };
//   }
//     // NEW: Handle pause doctor queue
//     if (action.type === CONFIRMED_PAUSE_DOCTOR_QUEUE) {
//       return {
//         ...state,
//         isPaused: action.payload.is_pause,
//       }
//     }


//     if (action.type === CONFIRMED_MARK_PATIENT_EMERGENCY) {
//       const updatedReceptionists = state.receptionists.map((patient) =>
//         patient.queue_id === action.payload.queue_id
//           ? { ...patient, is_emergency: action.payload.is_emergency }
//           : patient,
//       )

//       const updatedEmergencyPatients = [...state.emergencyPatients]
//       if (action.payload.is_emergency && !updatedEmergencyPatients.includes(action.payload.queue_id)) {
//         updatedEmergencyPatients.push(action.payload.queue_id)
//       } else if (!action.payload.is_emergency) {

//         const index = updatedEmergencyPatients.indexOf(action.payload.queue_id)
//         if (index > -1) {
//           updatedEmergencyPatients.splice(index, 1)
//         }
//       }

//       return {
//         ...state,
//         receptionists: updatedReceptionists,
//         emergencyPatients: updatedEmergencyPatients, t
//       }
//     }

//   return state;
// }
import {
  CONFIRMED_CREATE_RECEPTIONIST_ACTION,
  CONFIRMED_MARK_PATIENT_CURRENT,
  CONFIRMED_EDIT_RECEPTIONIST_ACTION,
  CONFIRMED_GET_RECEPTIONISTS,
  CONFIRMED_DELETE_RECEPTIONIST_ACTION,
  CONFIRMED_ADD_VITALS_ACTION,
  CONFIRMED_COLLECT_PAYMENT_ACTION,
  CONFIRMED_UPCOMING_APPOINTMENT,
  CONFIRMED_GET_AVAILABLE_SLOTS,
  CONFIRMED_RESCHEDULE_APPOINTMENT,
  CONFIRMED_RESCHEDULE_QUEUE_APPOINTMENT,
  CONFIRMED_SEND_FORM_LINK,
  CONFIRMED_PAUSE_DOCTOR_QUEUE,
  CONFIRMED_MARK_PATIENT_EMERGENCY,
  CONFIRMED_GET_BOOKED_APPOINTMENTS,
  FAILED_GET_BOOKED_APPOINTMENTS,
  CONFIRMED_RESCHEDULE_BOOKED_APPOINTMENT,
  MARK_PATIENT_NEXT_REQUEST,
  MARK_PATIENT_NEXT_SUCCESS,
  MARK_PATIENT_NEXT_FAILURE,
  CONFIRMED_SEND_REMINDER,CONFIRMED_GET_EMERGENCY_PATIENTS,
  CONFIRMED_ADD_BACK_TO_QUEUE,
  FAILED_ADD_BACK_TO_QUEUE,
  CONFIRMED_UPLOAD_PATIENT_PHOTO ,
  CONFIRMED_ADD_SEARCH_PATIENT_QUEUE,
FAILED_ADD_SEARCH_PATIENT_QUEUE
} from "../actions/ReceptionistTypes"

const initialState = {
  receptionists: [],
  vitals: [],
  currentPatient: null,
  upcomingAppointments: [],
  availableSlots: [],
  sentLinks: [],
  emergencyPatients: [],
  isPaused: false,
  lastPauseActionTimestamp: null,
  pausedDoctorId: null,
  // All doctors data (doctor_id = 0)
  bookedAppointments: [],
  bookedAppointmentsYes: [],
  bookedAppointmentsNo: [],
  // Selected doctor data (separate from all doctors)
  selectedDoctorAppointments: [],
  selectedDoctorAppointmentsYes: [],
  selectedDoctorAppointmentsNo: [],
  loadingNextPatient: false,
  emergencyPatientList: [],
  loading: false,
  lastFetchTimestamp: null,
  lastDoctorId: null,
}

export default function ReceptionistReducer(state = initialState, action) {

  if (action.type === CONFIRMED_GET_RECEPTIONISTS) {
    const { receptionists, isPaused: incomingIsPaused } = action.payload
    const now = Date.now()
    const isRecentPauseAction = state.lastPauseActionTimestamp && now - state.lastPauseActionTimestamp < 2000

    let newIsPaused = incomingIsPaused

    if (isRecentPauseAction && state.isPaused !== incomingIsPaused) {
      newIsPaused = state.isPaused // Keep the state from the recent pause/resume action
    }


    if (JSON.stringify(state.receptionists) !== JSON.stringify(receptionists) || state.isPaused !== newIsPaused) {
      return {
        ...state,
        receptionists,
        isPaused: newIsPaused,
      }
    }
    return state
  }

  if (action.type === CONFIRMED_CREATE_RECEPTIONIST_ACTION) {
    const receptionists = [...state.receptionists]
    receptionists.push(action.payload)
    return {
      ...state,
      receptionists,
    }
  }

  if (action.type === CONFIRMED_MARK_PATIENT_CURRENT) {
    return {
      ...state,
      currentPatient: action.payload,
    }
  }

  if (action.type === CONFIRMED_ADD_VITALS_ACTION) {
    const vitals = [...state.vitals]
    vitals.push(action.payload)
    return {
      ...state,
      vitals,
    }
  }

  if (action.type === CONFIRMED_COLLECT_PAYMENT_ACTION) {
    // No state update needed here based on the provided reducer logic
  }

  if (action.type === CONFIRMED_UPCOMING_APPOINTMENT) {
    return {
      ...state,
      upcomingAppointments: action.payload,
    }
  }

  if (action.type === CONFIRMED_GET_AVAILABLE_SLOTS) {
    return {
      ...state,
      availableSlots: action.payload,
    }
  }

  if (action.type === CONFIRMED_RESCHEDULE_APPOINTMENT) {
    const updatedAppointments = state.upcomingAppointments.map((appointment) =>
      appointment.queue_id === action.payload.queue_id ? action.payload : appointment,
    )
    return {
      ...state,
      upcomingAppointments: updatedAppointments,
    }
  }

  if (action.type === CONFIRMED_RESCHEDULE_QUEUE_APPOINTMENT) {
    const updatedAppointments = state.upcomingAppointments.map((appointment) =>
      appointment.queue_id === action.payload.queue_id ? action.payload : appointment,
    )
    return {
      ...state,
      upcomingAppointments: updatedAppointments,
    }
  }

  if (action.type === CONFIRMED_EDIT_RECEPTIONIST_ACTION) {
    const updatedList = state.receptionists.map((item) => (item.id === action.payload.id ? action.payload : item))
    return {
      ...state,
      receptionists: updatedList,
    }
  }

  if (action.type === CONFIRMED_DELETE_RECEPTIONIST_ACTION) {
    const filteredList = state.receptionists.filter((item) => item.id !== action.payload)
    return {
      ...state,
      receptionists: filteredList,
    }
  }

  if (action.type === CONFIRMED_SEND_FORM_LINK) {
    return {
      ...state,
      sentLinks: [...state.sentLinks, action.payload],
    }
  }

  if (action.type === CONFIRMED_PAUSE_DOCTOR_QUEUE) {
    return {
      ...state,
      isPaused: action.payload.is_pause,
      pausedDoctorId: action.payload.doctor_id,
      lastPauseActionTimestamp: Date.now(), // Set timestamp when pause action occurs
    }
  }

  // if (action.type === CONFIRMED_GET_BOOKED_APPOINTMENTS) {
  //   return {
  //     ...state,
  //     bookedAppointments: action.payload,
  //     loading: false,
  //   }
  // }
  if (action.type === CONFIRMED_GET_BOOKED_APPOINTMENTS) {
    const isPayment = action.meta?.isPayment;
    const doctorId = action.meta?.doctorId;
    
    // Deep comparison to prevent flickering
    const isDataChanged = (oldData, newData) => {
      return JSON.stringify(oldData) !== JSON.stringify(newData);
    };

    // CASE 1: Fetching ALL DOCTORS (doctor_id = 0)
    if (doctorId === 0 || String(doctorId) === "0") {
      if (isPayment === "Yes") {
        if (!isDataChanged(state.bookedAppointmentsYes, action.payload)) {
          return state;
        }
        
        // Merge Yes + No for all doctors
        const appointmentIdMap = new Map();
        action.payload.forEach(item => appointmentIdMap.set(item.id, item));
        state.bookedAppointmentsNo.forEach(item => {
          if (!appointmentIdMap.has(item.id)) {
            appointmentIdMap.set(item.id, item);
          }
        });
        
        const merged = Array.from(appointmentIdMap.values());
        
        return {
          ...state,
          bookedAppointmentsYes: action.payload,
          bookedAppointments: merged,
        };
      }

      if (isPayment === "No") {
        if (!isDataChanged(state.bookedAppointmentsNo, action.payload)) {
          return state;
        }
        
        // Merge Yes + No for all doctors
        const appointmentIdMap = new Map();
        state.bookedAppointmentsYes.forEach(item => appointmentIdMap.set(item.id, item));
        action.payload.forEach(item => {
          if (!appointmentIdMap.has(item.id)) {
            appointmentIdMap.set(item.id, item);
          }
        });
        
        const merged = Array.from(appointmentIdMap.values());
        
        return {
          ...state,
          bookedAppointmentsNo: action.payload,
          bookedAppointments: merged,
        };
      }
    }

    // CASE 2: Fetching SELECTED DOCTOR (doctor_id != 0)
    if (doctorId && doctorId !== 0 && String(doctorId) !== "0") {
      if (isPayment === "Yes") {
        if (!isDataChanged(state.selectedDoctorAppointmentsYes, action.payload)) {
          return state;
        }
        
        // Merge Yes + No for selected doctor
        const appointmentIdMap = new Map();
        action.payload.forEach(item => appointmentIdMap.set(item.id, item));
        state.selectedDoctorAppointmentsNo.forEach(item => {
          if (!appointmentIdMap.has(item.id)) {
            appointmentIdMap.set(item.id, item);
          }
        });
        
        const merged = Array.from(appointmentIdMap.values());
        
        return {
          ...state,
          selectedDoctorAppointmentsYes: action.payload,
          selectedDoctorAppointments: merged,
          lastDoctorId: doctorId,
        };
      }

      if (isPayment === "No") {
        if (!isDataChanged(state.selectedDoctorAppointmentsNo, action.payload)) {
          return state;
        }
        
        // Merge Yes + No for selected doctor
        const appointmentIdMap = new Map();
        state.selectedDoctorAppointmentsYes.forEach(item => appointmentIdMap.set(item.id, item));
        action.payload.forEach(item => {
          if (!appointmentIdMap.has(item.id)) {
            appointmentIdMap.set(item.id, item);
          }
        });
        
        const merged = Array.from(appointmentIdMap.values());
        
        return {
          ...state,
          selectedDoctorAppointmentsNo: action.payload,
          selectedDoctorAppointments: merged,
          lastDoctorId: doctorId,
        };
      }
    }

    return state;
  }
  if (action.type === FAILED_GET_BOOKED_APPOINTMENTS) {
    return {
      ...state,
      bookedAppointments: [],
      loading: false,
    }
  }

  if (action.type === CONFIRMED_RESCHEDULE_BOOKED_APPOINTMENT) {
    const updatedList = state.bookedAppointments.map((item) =>
      item.id === action.payload.appointment_id
        ? { ...item, ...action.payload }
        : item
    );
  
    return {
      ...state,
      bookedAppointments: updatedList,
    };
  }
  if (action.type === CONFIRMED_GET_EMERGENCY_PATIENTS) {
    return {
      ...state,
      emergencyPatientList: action.payload,
    };
  }
  if (action.type === CONFIRMED_MARK_PATIENT_EMERGENCY) {
    const updatedReceptionists = state.receptionists.map((patient) =>
      patient.queue_id === action.payload.queue_id
        ? { ...patient, is_emergency: action.payload.is_emergency }
        : patient,
    )
    const updatedEmergencyPatients = [...state.emergencyPatients]
    if (action.payload.is_emergency && !updatedEmergencyPatients.includes(action.payload.queue_id)) {
      updatedEmergencyPatients.push(action.payload.queue_id)
    } else if (!action.payload.is_emergency) {
      const index = updatedEmergencyPatients.indexOf(action.payload.queue_id)
      if (index > -1) {
        updatedEmergencyPatients.splice(index, 1)
      }
    }
    
    return {
      ...state,
      receptionists: updatedReceptionists,
      emergencyPatients: updatedEmergencyPatients,
    }
  }
  if (action.type === CONFIRMED_SEND_REMINDER) {
    const updated = state.bookedAppointments.map(item =>
      item.id === action.payload
        ? { ...item, reminder_sent: true }
        : item
    );
  
    return {
      ...state,
      bookedAppointments: updated,
    };
  }
  if (action.type === MARK_PATIENT_NEXT_REQUEST) {
    return {
      ...state,
      loadingNextPatient: true,
    };
  }
  
  if (action.type === MARK_PATIENT_NEXT_SUCCESS) {
  
    const updatedReceptionists = state.receptionists.map((patient) =>
      patient.queue_id === action.payload
        ? { ...patient, patient_marked: "Next" }
        : patient
    );
  
    return {
      ...state,
      loadingNextPatient: false,
      receptionists: updatedReceptionists,
    };
  }
  
  if (action.type === MARK_PATIENT_NEXT_FAILURE) {
    return {
      ...state,
      loadingNextPatient: false,
    };
  }
  if (action.type === CONFIRMED_ADD_BACK_TO_QUEUE) {
    const updatedReceptionists = state.receptionists.map((patient) =>
      patient.queue_id === action.payload
        ? { ...patient, patient_marked: "Waiting" }
        : patient
    );
  
    return {
      ...state,
      receptionists: updatedReceptionists,
    };
  }
  

  if (action.type === FAILED_ADD_BACK_TO_QUEUE) {
    return state;
  }
  
  if (action.type === CONFIRMED_UPLOAD_PATIENT_PHOTO) {
    const updatedReceptionists = state.receptionists.map((patient) =>
      patient.patient_id === action.payload.patient_id
        ? { ...patient, patient_photo: action.payload.patient_photo }
        : patient
    );
  
    return {
      ...state,
      receptionists: updatedReceptionists,
    };
  }
  if (action.type === CONFIRMED_ADD_SEARCH_PATIENT_QUEUE) {

    return {
      ...state,
      receptionists: [
        ...state.receptionists,
        action.payload
      ]
    };
  
  }
  
  if (action.type === FAILED_ADD_SEARCH_PATIENT_QUEUE) {
    return state;
  }

  return state
}
